// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Help & Support Component Styles
   ========================================== */

.help-wrapper {
  padding: 6rem 1.5rem 4rem 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.help-title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.help-subtitle {
  font-size: 1.1rem;
  color: var(--text-muted);
  margin-bottom: 2.5rem;
}

.search-box {
  max-width: 580px;
  margin: 0 auto 3rem auto;
}

.search-box input {
  width: 100%;
  padding: 1rem 1.75rem;
  font-size: 1rem;
  border-radius: var(--radius-full);
  background: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(16px);
  border: 1px solid var(--border-glass);
  color: #ffffff;
  outline: none;
  transition: all 0.3s ease;
}

.search-box input:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 25px rgba(245, 158, 11, 0.35);
}

.popular-section {
  margin-bottom: 3.5rem;
}

.popular-section h3 {
  font-size: 1.35rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 1rem;
}

.popular-section ul {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.popular-section li {
  font-size: 0.9rem;
  color: #a5b4fc;
  background: rgba(245, 158, 11, 0.12);
  border: 1px solid rgba(245, 158, 11, 0.25);
  padding: 0.5rem 1.25rem;
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all 0.3s ease;
}

.popular-section li:hover {
  background: rgba(245, 158, 11, 0.25);
  color: #ffffff;
  transform: translateY(-2px);
}

.faq-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 4rem;
  text-align: left;
}

.faq-card {
  background: var(--bg-glass-card);
  backdrop-filter: blur(16px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  padding: 1.75rem;
  transition: all 0.3s ease;
}

.faq-card:hover {
  transform: translateY(-5px);
  border-color: var(--border-glass-hover);
  box-shadow: var(--shadow-md);
}

.category {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  background: rgba(6, 182, 212, 0.15);
  border: 1px solid rgba(6, 182, 212, 0.3);
  color: #38bdf8;
  padding: 0.3rem 0.8rem;
  border-radius: var(--radius-full);
  margin-bottom: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.faq-card h3 {
  font-size: 1.15rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.faq-card p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.6;
}

.help-cta {
  background: var(--grad-surface);
  border: 1px solid var(--border-glass);
  padding: 3.5rem 2rem;
  border-radius: var(--radius-lg);
  max-width: 750px;
  margin: 0 auto;
}

.help-cta h3 {
  font-size: 1.75rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.75rem;
}

.help-cta p {
  color: var(--text-muted);
  margin-bottom: 1.75rem;
}

.contact-btn {
  padding: 0.85rem 2rem;
  font-size: 1rem;
  font-weight: 700;
  background: var(--grad-primary);
  color: #ffffff;
  border: none;
  border-radius: var(--radius-full);
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.4);
  transition: all 0.3s ease;
}

.contact-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(245, 158, 11, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Help.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;EAC3B,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,0CAA0C;EAC1C,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,sBAAsB;EACtB,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD","sourcesContent":["/* ==========================================\n   Kubersetu Help & Support Component Styles\n   ========================================== */\n\n.help-wrapper {\n  padding: 6rem 1.5rem 4rem 1.5rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.help-title {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.help-subtitle {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n  margin-bottom: 2.5rem;\n}\n\n.search-box {\n  max-width: 580px;\n  margin: 0 auto 3rem auto;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 1rem 1.75rem;\n  font-size: 1rem;\n  border-radius: var(--radius-full);\n  background: rgba(15, 23, 42, 0.75);\n  backdrop-filter: blur(16px);\n  border: 1px solid var(--border-glass);\n  color: #ffffff;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.search-box input:focus {\n  border-color: var(--color-primary);\n  box-shadow: 0 0 25px rgba(245, 158, 11, 0.35);\n}\n\n.popular-section {\n  margin-bottom: 3.5rem;\n}\n\n.popular-section h3 {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 1rem;\n}\n\n.popular-section ul {\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.popular-section li {\n  font-size: 0.9rem;\n  color: #a5b4fc;\n  background: rgba(245, 158, 11, 0.12);\n  border: 1px solid rgba(245, 158, 11, 0.25);\n  padding: 0.5rem 1.25rem;\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.popular-section li:hover {\n  background: rgba(245, 158, 11, 0.25);\n  color: #ffffff;\n  transform: translateY(-2px);\n}\n\n.faq-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 4rem;\n  text-align: left;\n}\n\n.faq-card {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(16px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  padding: 1.75rem;\n  transition: all 0.3s ease;\n}\n\n.faq-card:hover {\n  transform: translateY(-5px);\n  border-color: var(--border-glass-hover);\n  box-shadow: var(--shadow-md);\n}\n\n.category {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 700;\n  background: rgba(6, 182, 212, 0.15);\n  border: 1px solid rgba(6, 182, 212, 0.3);\n  color: #38bdf8;\n  padding: 0.3rem 0.8rem;\n  border-radius: var(--radius-full);\n  margin-bottom: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.faq-card h3 {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.faq-card p {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.help-cta {\n  background: var(--grad-surface);\n  border: 1px solid var(--border-glass);\n  padding: 3.5rem 2rem;\n  border-radius: var(--radius-lg);\n  max-width: 750px;\n  margin: 0 auto;\n}\n\n.help-cta h3 {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.75rem;\n}\n\n.help-cta p {\n  color: var(--text-muted);\n  margin-bottom: 1.75rem;\n}\n\n.contact-btn {\n  padding: 0.85rem 2rem;\n  font-size: 1rem;\n  font-weight: 700;\n  background: var(--grad-primary);\n  color: #ffffff;\n  border: none;\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.4);\n  transition: all 0.3s ease;\n}\n\n.contact-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 30px rgba(245, 158, 11, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
